import { render } from "./International_Treatment_Guide.vue?vue&type=template&id=631318bf"
import script from "./International_Treatment_Guide.vue?vue&type=script&lang=js"
export * from "./International_Treatment_Guide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__